import { call } from '@redux-saga/core/effects';
import { toastr } from 'react-redux-toastr';

export function* handleSuccessSaga(success: string) {
  yield call(toastr.success, 'Success', success);
}
